import React, { Component } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import Moment from 'moment'
import { GenerateKeyV2 } from '../GenerateKey/generatekeymodalV2';
import ConfirmationModal from '../Components/ConfirmationModal';
import './dashboard.css';
let csrfToken;

export class Dashboard extends Component {
    state = {
        licenseData: [],
        allLicenseData: [],
        orgNameFilter: '',
        showActiveOnly: false,
        loggedIn: true,
        isFetching: false,
        selectedVastID:null,
        selectedExpirationDate:null,
        openConfirmationModal:false,
        pendingSelectedVastID:null
    }

    componentDidMount(){
        if(!localStorage.getItem('login')){
            this.setState({loggedIn: localStorage.getItem('login')})
        }
        else{
            this.fetchLicenseData()
        }
    }

    // Activated licenses first, then the not activated ones
    sortByActivationStatus = (data) => {
        return [...data].sort((a, b) => (b.activation_status ? 1 : 0) - (a.activation_status ? 1 : 0))
    }

    fetchLicenseData = (keepFilters = true) => {
        this.setState({isFetching: true})
        fetch(`/license/dashboard/`)
            .then(res => res.json())
            .then(response => {
                if(response.success){
                    const sorted = this.sortByActivationStatus(response.Data)
                    this.setState(
                        {allLicenseData: sorted, licenseData: sorted, isFetching: false},
                        () => { if(keepFilters) this.applyFilters() }
                    )
                }
                else{
                    this.setState({isFetching: false})
                }
            })
            .catch(error => {
                console.error(error)
                this.setState({isFetching: false})
            });
    }

    handleOrgNameFilterChange = (e) => {
        this.setState({orgNameFilter: e.target.value})
    }

    handleActiveOnlyChange = (e) => {
        this.setState({showActiveOnly: e.target.checked}, this.applyFilters)
    }

    applyFilters = () => {
        const { orgNameFilter, showActiveOnly, allLicenseData } = this.state
        const searchTerm = orgNameFilter.trim().toLowerCase()
        let filtered = allLicenseData
        if(searchTerm){
            filtered = filtered.filter(data =>
                data.organization && data.organization.toLowerCase().includes(searchTerm)
            )
        }
        if(showActiveOnly){
            filtered = filtered.filter(data => data.activation_status)
        }
        this.setState({licenseData: this.sortByActivationStatus(filtered)})
    }

    handleSearch = () => {
        this.applyFilters()
    }

    handleResetFilter = () => {
        this.setState({orgNameFilter: '', showActiveOnly: false}, () => this.fetchLicenseData(false))
    }

    handleFetchRecords = () => {
        this.fetchLicenseData()
    }

    handleupgradeLicense = (vast_id, expiration_date) => {
        console.log("expiration_date ",expiration_date)
        this.setState({selectedExpirationDate:expiration_date, openConfirmationModal:true,pendingSelectedVastID:vast_id})
    }

    handleGoAhead = () => {
        console.log("go ahead")
        this.setState({openConfirmationModal:false, selectedVastID:this.state.pendingSelectedVastID})
    }

    handleCloseModal = ()=>{
        this.setState({selectedVastID:null,pendingSelectedVastID:null, selectedExpirationDate:null, openConfirmationModal:false})
    }

    render() {
        if(!this.state.loggedIn){
            return <Redirect to="/login" />
        }
        return (
            <div style={{width: '100%', overflow: 'auto'}} >
                <div className='dashboard-toolbar mx-3'>
                    <div className="dashboard-search">
                        <span className="dashboard-search-icon">&#128269;</span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by Organization Name"
                            value={this.state.orgNameFilter}
                            onChange={this.handleOrgNameFilterChange}
                            onKeyDown={(e) => { if(e.key === 'Enter') this.handleSearch() }}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-search"
                        onClick={this.handleSearch}
                    >
                        Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-reset"
                        onClick={this.handleResetFilter}
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        className="btn btn-fetch"
                        onClick={this.handleFetchRecords}
                        disabled={this.state.isFetching}
                    >
                        {this.state.isFetching ? 'Fetching...' : 'Fetch Records'}
                    </button>
                    <div className="dashboard-active-toggle">
                        <input
                            type="checkbox"
                            id="showActiveOnly"
                            checked={this.state.showActiveOnly}
                            onChange={this.handleActiveOnlyChange}
                        />
                        <label htmlFor="showActiveOnly">
                            Show only Active License
                        </label>
                    </div>
                </div>
                <table className="table table-hover DivcolorWhite cusTable tableScrollDiv" style={{marginTop: "15px"}}>
                    <thead>
                        <tr style={{fontSize: '14px'}}>
                            <th scope="col">#</th>
                            <th scope="col">Organization</th>
                            <th scope="col">VAST ID</th>
                            <th scope="col">Expiration Date</th>
                            <th scope="col">Activation Status</th>
                            <th scope="col">Activation Date</th>
                            <th scope="col">License Type</th>
                            <th scope="col">License Key</th>
                            <th scope="col">OTP</th>
                            <th scope="col">New License</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* {console.log("this.state.licenseData ",this.state.licenseData)} */}
                        {this.state.licenseData.map((data, i)=>(
                            <tr
                                key={data.vast_id ? `${data.vast_id}-${i}` : i}
                                className={data.activation_status ? 'license-row-active' : 'license-row-inactive'}
                                style={{fontSize: '12px'}}
                            >
                                <td>{i+1}</td>
                                <td>{data.organization?data.organization:'-'}</td>
                                <td title={data.vast_id?data.vast_id:'---'}>{data.vast_id?`${data.vast_id.slice(0,10)}...`:'---'}</td>
                                <td>{data.validity?data.validity:'---'}</td>
                                <td>
                                    <span className={data.activation_status ? 'license-status license-status-active' : 'license-status license-status-inactive'}>
                                        {data.activation_status?'Activated':'Not Activated'}
                                    </span>
                                </td>
                                <td>{data.activation_date?Moment(data.activation_date).format("MMM DD YYYY, HH:mm:ss"):'---'}</td>
                                <td>{data.license_type?data.license_type:'---'}</td>
                                <td title={data.license_key?data.license_key:'---'}>{data.license_key?`${data.license_key.slice(0,7)}...`:'---'}</td>
                                <td>{data.otp?data.otp:'---'}</td>
                                <td>
                                    {console.log("data ",data)}
                                    {
                                        data.license_type
                                        ?
                                        'N/A'
                                        :
                                    <button 
                                        style={{
                                            padding:"5px 10px",
                                            backgroundColor:"lightgray",
                                            border:"none",
                                            borderRadius:"3px"
                                        }}
                                        data-toggle="modal"
                                        data-target="#genrate_key_modalv2"
                                        data-backdrop="static"
                                        onClick={()=>this.handleupgradeLicense(data.vast_id,data.validity)}
                                    >
                                            Extend/Upgrade
                                    </button>
                                    }
                                </td>
                            </tr>
                        ))}
                        {this.state.licenseData.length === 0 &&
                            <tr className="dashboard-empty-row">
                                <td colSpan="10">{this.state.isFetching ? 'Fetching records...' : 'No records found'}</td>
                            </tr>
                        }
                    </tbody>
                </table>
                {
                    this.state.openConfirmationModal
                    ?
                    <ConfirmationModal
                        open={this.state.openConfirmationModal}
                        ExiprationDate={this.state.selectedExpirationDate}
                        handleCloseModal={this.handleCloseModal}
                        handleGoAhead={this.handleGoAhead}
                    />
                    : 
                        this.state.selectedVastID
                        ?
                        <GenerateKeyV2
                            handleCloseModal={this.handleCloseModal}
                            open={true}
                            isEdit={true}
                            vast_id={this.state.selectedVastID}
                        />
                        :
                        <></>
                }
                {/* {
                    this.state.selectedVastID
                    ?
                    <GenerateKeyV2
                        handleCloseModal={this.handleCloseModal}
                        open={true}
                        isEdit={true}
                        vast_id={this.state.selectedVastID}
                    />
                    :
                    <></>
                } */}
            </div>
            
        )
    }
}

// const


export default connect(Dashboard)

